import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { DropModel, DropParcelsRequest } from "../api/drop.api"

export interface DropsListState {
    drops: DropModel[]
    loading: boolean
    error?: string
    success?: boolean
    parcelsToDrop?: number[]
}

const initialState: DropsListState = {
    drops: [],
    loading: false
}

export const loadDrops = createAsyncThunk(
    "drops/list",
    async ({ warehouse }: { warehouse?: string }, thunkAPI) => {
        try {
            const response = await api.drop.dropsList({ warehouse })

            return response
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const dropParcels = createAsyncThunk(
    "drop/parcels",
    async (dropParcelsRequestData: DropParcelsRequest, thunkAPI) => {
        try {
            const response = await api.drop.dropParcels(dropParcelsRequestData)

            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const dropsSlice = createSlice({
    name: "drops",
    initialState,

    reducers: {
        clearError: (state: DropsListState) => {
            state.error = undefined
        },
        resetSuccess: (state: DropsListState) => {
            state.success = undefined
        }
    },

    extraReducers: {
        [loadDrops.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadDrops.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [loadDrops.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.drops = action.payload?.data?.payload || []
        },

        [dropParcels.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [dropParcels.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [dropParcels.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
        }
    }
})

export const { clearError, resetSuccess } = dropsSlice.actions

export default dropsSlice.reducer
